import { FC } from 'react';
import styles from './matter-news.module.css';

export interface IMatterNewsProps {
  origin: string;
  category: string;
  image: string;
  date: string;
  authorRead: string;
  authorPicture: string;
  newsContent: string;
}

export const MatterNews: FC<IMatterNewsProps> = ({
  image,
  newsContent,
}) => {
  return (
    <div className={styles.containerContent}>
      <div className={styles.containerNews}>
        <div className={styles.containerImageBox}>
          <img src={image} alt="Imagem da matéria" />
        </div>

        <div className={styles.containerTextBox}>
          <div
            dangerouslySetInnerHTML={{
              __html: newsContent,
            }}
          />
        </div>
      </div>

      <div className={styles.containerShare} />
    </div>
  );
};